import IcModalFullscreen from './IcModalFullscreen'
export default IcModalFullscreen
